import React, { useState } from "react";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import { Link } from "react-router-dom";

import Arrow from "./Arrow";
import Generalsidebar from "./Generalsidebar";

const Jokes = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  function handleArrowClick() {
    setShowSidebar(true);
  }

  const initialJokes = [
    "Q: What do you call fake spaghetti? A: An impasta!",
    "Q: What do you call a fish wearing a crown A: A kingfish",
    "Q: What's orange and sounds like a parrot A: A carrot",
    "Q: How do you organize a space party? A: You planet!",
    "Q: What's a vampire's favorite fruit?A: A blood orange!",
    "Q: How does a penguin build its house? A: Igloos it together!",
    "Q: How do you organize a space party? A: You planet!",
    "Q: Why did the bicycle fall over? A: Because it was two-tired!",
  ];

  const [currentJoke, setCurrentJoke] = useState("");

  const generateJoke = () => {
    const randomIndex = Math.floor(Math.random() * initialJokes.length);
    console.log("i love Rahmat");
    setCurrentJoke(initialJokes[randomIndex]);
  };

  return (
    <>
      <Navbar />

      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <section>
        <div className="text-black ml-20 mt-5">
          <Link to="/mainresources">
            <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              Back
            </button>
          </Link>
        </div>
        <h1 className="font-bold flex justify-center text-[#152C00] text-4xl">
          Riddles
        </h1>
        <div className="lg:items-center justify-center mx-20 my-5 px-10 py-7 bg-[#DCAE96] mb-10">
          <div className="w-full md:grid md:justify-center md:items-center md:place-content-center">
            <div>
              <img
                src="https://res.cloudinary.com/dmvphwhvc/image/upload/v1700649843/sbb8u1khnfyo8nfmmfhy.png"
                alt="Riddle emoji"
              ></img>
            </div>
          </div>
          <div className="flex justify-center text-m text-[#152C00] shadow-[#152C00]">
            <div className="p-10 rounded-md text-[#152C00] shadow-green-700">
              <p className="text-xl">{currentJoke}</p>
            </div>
          </div>
          <div className="flex justify-center">
            <button
              className="rounded py-2 px-4 text-white text-m bg-[#314C1C] hover:bg-[#489f3e]"
              onClick={generateJoke}
            >
              GENERATE JOKE
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Jokes;
